// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-pages-Project-Settings-Dashboards-Toolbar-___styles-module__container {
  border: 1px solid #e8e8e8;
  padding: 10px;
  max-height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./app/pages/Project/Settings/Dashboards/Toolbar/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB","sourcesContent":[".container {\n  border: 1px solid #e8e8e8;\n  padding: 10px;\n  max-height: 50px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `app-pages-Project-Settings-Dashboards-Toolbar-___styles-module__container`
};
export default ___CSS_LOADER_EXPORT___;
